export const ModelA = {
    name :  { path: ".name" },
    type : { 
        path: ".type" ,
        _default: {
            paragraph: "label",
            link: "label",
            label: "label",
        },
        fieldValidate: '.inputType',
        addDefault: ["paragraph", "link", "label"],      
    },
    label : { path: ".label" },
    required : { path: ".required" },
    inputType : { path: ".inputType" },
    help: {
        path: ".help",
        _default: ""
    },
    maxLength: {
        path: ".maxLength",
        fieldValidate: '.inputType',
        valuesValidate: ["barcode"]
    },
    content: { 
        path: ".content",
        _default: 'DEFAULT',
        fieldValidate: '.inputType',
        valuesValidate: ["label", "link", "paragraph", "web", "document"]
    },
    options: {
        path: "n/a",
        _default: ["all"],
        fieldValidate: '.inputType',
        valuesValidate: ["email"]
    },    
    properties: {
        path: ".properties",
        fieldValidate: '.inputType',
        valuesValidate: ["default", "textarea", "number", "currency", "label", "checktext", "link", "paragraph", "slider", "web", "document", "datasource"],
        _properties: {
            min: {
                path: ".n/a",
                _default: 1,//Si el componente no tiene la propiedad min
                fieldValidate: '.inputType',
                valuesValidate: ["default", "textarea", "number", "currency", "checktext"]
            },
            max: {
                path: {
                    checktext: '.maxLength',
                    default: '.maxLength',
                    textarea: '.maxLength',
                    number: '.n/a',
                    currency: '.n/a',
                },
                _default: 1,//Si el componente no tiene la propiedad max
                fieldValidate: '.inputType',
                valuesValidate: ["default", "textarea", "number", "currency", "checktext"]
            },
            default: {
                path: {
                    label: ".properties.default",
                    link : ".properties.default",
                    paragraph : ".properties.default",
                    slider : ".properties.default",
                    paragraph : ".properties.default",    
                    web: ".properties.default",            
                    document: ".properties.default",            
                } ,
                _default: {
                    slider: 1,
                    link: "external",
                    paragraph: "content",
                },//Si el componente no tiene la propiedad default
                fieldValidate: '.inputType',
                valuesValidate: ["label", "link", "paragraph", "slider", "paragraph", "web", "document"]
            },
            size: {
                path: ".properties.size",
                _default: 1,//Si el componente no tiene la propiedad max
                fieldValidate: '.inputType',
                valuesValidate: ["label"],
                handler:(value) => parseInt(value)
            },       
            orientation: {
                path: ".properties.orientation",
                _default: "horizontal",//Si el componente no tiene la propiedad orientation
                fieldValidate: '.inputType',
                valuesValidate: ["slider", "web", "document"]
            },
            color: {
                path: ".n/a",
                _default: "#000000",
                fieldValidate: '.inputType',
                valuesValidate: ["slider", "label", "link"]
            },
            minValue: {
                 path:  {
                    number: '.n/a',
                    currency: 'n/a',
                    slider: ".properties.min"
                },
                _default: 0,
                fieldValidate: '.inputType',
                valuesValidate: ["slider", "number", "currency"],
            },
            maxValue: {
                path:  {
                    number: '.maxLength',
                    currency: '.maxLength',
                    slider: ".properties.max"
                },
                _default: 1,
                fieldValidate: '.inputType',
                valuesValidate: ["slider", "number", "currency",],
            },            
        }         
    },
    related: {
        path: ".related",
        _optional: true
    }
}